import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-291f80ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sw-chip--icon"
}
const _hoisted_2 = { class: "sw-chip--label" }

import { IconType } from '@/types/ui-components';
import {
  computed, withDefaults,
} from 'vue';

interface Props {
  icon?: IconType;
  label?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SwChip',
  props: {
    icon: { default: 'sw-icon-like' },
    label: { default: '' }
  },
  setup(__props: any) {



/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-chip': true,
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("i", {
            class: _normalizeClass(__props.icon)
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1)
  ], 2))
}
}

})